import React from 'react'
import SidePanelLayout from 'aldoo-ra/SidePanel'
import Pages from './Pages'
import Components from './Components'

const Structure = () => {
  return (
    <SidePanelLayout
      menuName="AdminStructureMenu"
      tabs={{
        pages: Pages,
        components: Components,
      }}
    />
  )
}

export default Structure